import { databaseDate } from '@intrasync/utils';
import ServiceStore from 'stores/ServiceStore';
import { RouteType } from 'types/RouteType';

const productionMonitorRoutes: RouteType[] = [
  {
    name: 'Production Monitor',
    path: '/production-monitor',

    layout: '/app',
    viewportCard: {
      header: {
        title: 'Production Monitor',
        component: () => import('./ProductionMonitor.Header'),
        enableRefreshButton: true,
        enableBackButton: true,
      },
      body: {
        component: () => import('./ProductionMonitor.Body'),
        grayBackground: true,
      },
    },
    requiresAuth: true,
    requiresPermission: false,
    hidden: false,
    channels: ['production-monitor'],
    enableAutoFind: false,

    defaultQueryParams: { castingDate: databaseDate() },

    onEnter: async ({ rootStore }) => {
      const panelStore = rootStore.panelStore as ServiceStore;
      panelStore.find({
        query: {
          castingDate: databaseDate(),
        },
      });
    },
  },
];

export default productionMonitorRoutes;
